import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import SearchListItem from './SearchListItem.jsx';
import SearchPageForm from './SearchPageForm.jsx';
import { appContext, loadAction } from '../../util/decorators';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import loadDataSources from 'action/loadDataSources';
import trackSearch from 'action/trackSearch';
import loadTagValues from 'action/loadTagValues';
import InfiniteScrollLoader from '../InfiniteScrollLoader';

const LOAD_COUNT = 50;

const $loadAction = (args) => loadDataSources({
  dataSourceConfigs: {
    search: 'search',
  },
  limit: {
    search: LOAD_COUNT,
  },
  ...args});

const $availableTypesAction = args => loadTagValues({
  tag: 'videoTypes',
  country: args.country,
});

const $trackAction = (args, dataSourceResponse) => trackSearch({
  q: args.search.q,
  totalHits: _.get(dataSourceResponse, 'payload.search.data.total'),
});

const mapStateToProps = state => ({
  q: state.search.q,
  videoType: state.search.videoType,
  searchResults: _(state.dataSources.search).map('embedded.posts').flatten().value(),
  totalHits: _.get(state, 'dataSources.search[0].data.total'),
  country: state.country,
});

@connect(mapStateToProps)
@loadAction($loadAction, $trackAction)
@loadAction($availableTypesAction)
@appContext
export default class SearchPage extends React.PureComponent {
  static propTypes = {
    searchResults: React.PropTypes.array,
    q: React.PropTypes.string,
    videoType: React.PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.currentOffset = _.size(props.searchResults) || LOAD_COUNT;
  }

  loadMore() {
    const { q, videoType, country, dispatch } = this.props;

    const promise = dispatch($loadAction({
      offset: {
        search: this.currentOffset,
      },
      search: {
        q,
        videoType,
      },
      country,
    }));

    this.currentOffset += LOAD_COUNT;

    return promise;
  }

  componentDidUpdate(previousProps) {
    if (previousProps.q !== this.props.q) {
      this.currentOffset = LOAD_COUNT;
    }
  }

  render() {
    const t = this.context.app.t;
    const { searchResults, totalHits } = this.props;

    if (!searchResults) return null;

    const resultList = _.map(searchResults, result => {
      return (
        <div key={result.data.id}>
          <SearchListItem contentContainer={{ ...result.data, ...result.embedded }} />
          <hr className="search-delimiter" />
        </div>
      );
    });

    return (
      <PageWithSidebars>
        <div className="search-page">
          <SearchPageForm q={this.props.q} videoType={this.props.videoType} />

          {this.props.q ?
            <div>
              <h2 className="search-label">
                {totalHits} {t('SearchPage.results_for')} <span className="search-query">{`"${this.props.q}"`}</span>
              </h2>
              <div>{resultList}</div>
              <InfiniteScrollLoader lastRequestedOffset={this.currentOffset}
                                    loadedOffset={_.size(searchResults)}
                                    loadMore={() => this.loadMore()}/>
            </div>
          : null}
        </div>
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Search/SearchPage.jsx